import { ApiEndpoints } from '@shared/api/api-endpoints';
import { cxApiClient, onboardingApiClient } from '@shared/api/clients/apiClientFactory';
import { transformJsonToObject } from '@shared/utils/jsonToObjectTransformer';

// Add your feature-specific API calls here
export const profileApi = {
  getConsumerDetail: async (params: { remote_utility_id: number; consumer_no: string }): Promise<any> => {
    const response = await cxApiClient.get(
      `consumer-detail/?remote_utility_id=${params.remote_utility_id}&consumer_no=${params.consumer_no}`
    );
    return response.data;
  },
  getMeterList: async (params: {
    remote_utility_id: string | number;
    consumer_id: string | number;
    remote_meter_id: string | number;
    is_status: boolean;
    page: any;
    limit: any;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "consumerWeb",
      "meter-reading",
      (qs: any) => {
        qs.push("remote_utility_id", String(params.remote_utility_id));
        qs.push("consumer_id", String(params.consumer_id));
        qs.push("remote_meter_id", String(params.remote_meter_id));
        qs.push("is_status", params.is_status);
        qs.push("page", params.page);
        qs.push("limit", params.limit);
      }
    );
    const response = await cxApiClient.get(url);
    return response.data;
  },
  getContract: async (params: {
    remoteUtilityId: string;
    contractId?: string | number | (string | number)[];
  }): Promise<{ result: any }> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "contract",
      (qs: any) => {
        qs.push("remote_utility_id", params.remoteUtilityId);
        if (params.contractId) {
          if (Array.isArray(params.contractId)) {
            params.contractId.forEach((id) => {
              if (id !== undefined && id !== null && id !== "") {
                qs.push("contract_id", id.toString());
              }
            });
          } else {
            qs.push("contract_id", params.contractId.toString());
          }
        }
      }
    );
    const response = await onboardingApiClient.get<{ result: any }>(url);
    return transformJsonToObject<{ result: any }>(response.data);
  },
  getDocuments: async (
    id: string,
    filters: any = {},
  ): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "cx",
      "consumer-document",
      (query: any) => {
        query.push("consumer_id", id);
        query.push("is_pagination_required", "True");
        if (filters.page) query.push("page", filters.page.toString());
        if (filters.limit) query.push("limit", filters.limit.toString());
        if (filters.date_range?.start)
          query.push("start_date", filters.date_range.start);
        if (filters.date_range?.end)
          query.push("end_date", filters.date_range.end);
        if (filters.query) query.push("query", filters.query);

        if (filters.sort_field) query.push("sort_field", filters.sort_field);
        if (filters.sort_direction)
          query.push("sort_direction", filters.sort_direction);
        if (filters.remote_utility_id) query.push("remote_utility_id", filters.remote_utility_id.toString());
        return query;
      },
    );

    const response = await cxApiClient.get(url);
    const transformedResponse = transformJsonToObject<any>(response.data);
    return transformedResponse;
  },
  updateConsumer: async (consumerId: string | number, payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrl("consumerWeb", `consumer/${consumerId}`);
    const response = await cxApiClient.put(url, payload);
    return response.data;
  },
};
